/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function tipHeight(){
    jQuery.fn.setMinHeight = function(setCount) {
        for(var i = 0; i < this.length; i+=setCount) {
            var curSet = this.slice(i, i+setCount), 
            height = 0;
            curSet.each(function() { height = Math.max(height, jQuery(this).height()); })
            .css('min-height', height);
        }
            return this;
    }; 
}
tipHeight();

function initHeightGridItems(){
    if ($(window).width() <= 767) {
        jQuery('.ProductList--grid .ProductItem__Title').setMinHeight(2);
    }
}
initHeightGridItems();


function stickyFilterCollection(){
    if($('body').hasClass('template-collection')){
        setTimeout(function(){
            var heightHeader = $('#shopify-section-header').height();
            $('.box-header-collection').css({'top' : heightHeader, 'position' : 'sticky'});
        }, 1500);
    }
}
stickyFilterCollection();

function skuSoldout(element, parent){

    var optionColor = element.split("/")[0];
    optionColor = $.trim(optionColor);

    parent.find(".ProductForm__Label[name=Tamanho] .SizeSwatchList input").removeClass("disabled");

    parent.find(".no-js.ProductForm__Option select option").each(function(i, e){
        var option = e.text.split("/")[0];
        option = $.trim(option);

        if (optionColor == option){
            var data_option_sold_out = $(this).attr("data-option-sold-out");
            
            parent.find(".ProductForm__Option[name=Tamanho] .SizeSwatchList li").each(function(){
                var data_value = $(this).attr("data-value");
                
                if(data_value == data_option_sold_out){
                    $("label", this).addClass("disabled");
                }
            });
        }
    });   
    setClassDisableSoldout(parent);
}
if($('body').hasClass('template-product')){
    skuSoldout($('.SizeSwatchList input:checked').val(), $('.Product__Info'));
}

function setClassDisableSoldout(parent){
    parent.find(".variant-input-wrap[name=Tamanho] .variant-input").each(function(){
        if ($(this).find("input").hasClass("disabled")){
            $(this).find("label").addClass("disabled")
        }
    });
}

function setArrowCustomFlickity(){
    var arrowSVG = ''          
    arrowSVG += `
        <svg name="arrow-custom-flickity" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 56 104" style="enable-background:new 0 0 56 104;" xml:space="preserve">
        <polygon class="st0" points="55.4,52.4 56.1,51.7 5.2,0.8 0.9,5 47.6,51.7 0.2,99.1 4.5,103.3 51.8,55.9 51.8,55.9 54,53.7 55.4,52.4 "/>
        </svg>                           
    `
    $('.flickity-prev-next-button').html(arrowSVG); 
}
setArrowCustomFlickity();

function setArrowCustomFlickityRecentlyViewedProducts(){
    if ($('body').hasClass('template-product')){
        console.log('template-product');
        setInterval(function(){
            setArrowCustomFlickity();
        }, 2000);
    }
} 
setArrowCustomFlickityRecentlyViewedProducts();

function sortMobile() {
    if($(window).width() <= 768){
        $("#collection-filter-drawer .Drawer__Main").append($("#collection-sort-popover"));
    }

    $("#collection-sort-popover .Popover__Close").click(function() {
        $("#collection-sort-popover").toggleClass("sort-open");
        $("#collection-sort-popover .Popover__ValueList").slideToggle("slow");;
      });
}
$(document).ready(function() {
sortMobile();
});

function filterColapse() {
    $(".boost-pfs-filter-tree .boost-pfs-filter-option").click(function() {
        alert("clicou");
        $(".boost-pfs-filter-tree .boost-pfs-filter-option .boost-pfs-filter-option-content").toggleClass("open");
    });
}

// function TradudirFilterCollectionEscape(){
//     if(window.location.pathname == "/search"){
//         if($('.boost-pfs-filter-options-wrapper').children().length == 3){
//             let $filter_1 = $('.boost-pfs-filter-option-title-text').eq(0).text().trim(), 
//                 $filter_2 = $('.boost-pfs-filter-option-title-text').eq(1).text().trim(), 
//                 $filter_3 = $('.boost-pfs-filter-option-title-text').eq(2).text().trim();
    
//             if( $filter_1 == "Vendor" && $filter_2 == "Product Type" && $filter_3 == 'Price (R$)' ){
//                 $('.boost-pfs-filter-option-title-text').eq(0).text('Fornecedor');
//                 $('.boost-pfs-filter-option-title-text').eq(1).text('Tipo de Produto');
//                 $('.boost-pfs-filter-option-title-text').eq(2).text('Preço (R$)');
//             }
//         }
//     }
// }

window.onload = function() {
    //filterColapse();
//     TradudirFilterCollectionEscape();
};
